export function validateEmail(email) {
    let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test ( email );
}

export function checkJmbgValidity(jmbg , message) {
    let controlNum;
    let modulo;
    if(!!jmbg){
    controlNum = jmbg.toString ()[12];
    modulo = 11 - ((
        7 * (parseInt ( jmbg[0] ) + parseInt ( jmbg[6] ))
        + 6 * (parseInt ( jmbg[1] ) + parseInt ( jmbg[7] ))
        + 5 * (parseInt ( jmbg[2] ) + parseInt ( jmbg[8] ))
        + 4 * (parseInt ( jmbg[3] ) + parseInt ( jmbg[9] ))
        + 3 * (parseInt ( jmbg[4] ) + parseInt ( jmbg[10] ))
        + 2 * (parseInt ( jmbg[5] ) + parseInt ( jmbg[11] )))
        % 11);
    if (modulo>9) {
        modulo = 0;
    }
    }
    if (parseInt ( controlNum ) !== modulo) {
        return message;
    } else {
        return false
    }
}

export function formatDate(date) {
    let d = new Date ( date ) ,
        month = '' + (d.getMonth () + 1) ,
        day = '' + d.getDate () ,
        year = d.getFullYear ();

    if (month.length<2)
        month = '0' + month;
    if (day.length<2)
        day = '0' + day;

    return [year , month , day].join ( '-' );
}

export function getAge(jmbg) {
    let birthDate = jmbg.substr ( 0 , 7 );
    let year = birthDate.substr ( 4 , 3 );
    let yearNum = parseInt ( year );
    let fullYear = 1000 - yearNum<100 ? "1" + year : "2" + year;
    let birthDateString = new Date ( birthDate = fullYear + "-" + jmbg.substr ( 2 , 2 ) + "-" + jmbg.substr ( 0 , 2 ) );
    let today = new Date ();
    return new Date ( (today - birthDateString) ).getFullYear () - 1970;
}